/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GeoFormData,
    GeoFormDataFromJSON,
    GeoFormDataFromJSONTyped,
    GeoFormDataToJSON,
} from './';

/**
 * 
 * @export
 * @interface BCMOsisRuleFormDataRouteRestriction
 */
export interface BCMOsisRuleFormDataRouteRestriction {
    /**
     * 
     * @type {GeoFormData}
     * @memberof BCMOsisRuleFormDataRouteRestriction
     */
    from?: GeoFormData;
    /**
     * 
     * @type {GeoFormData}
     * @memberof BCMOsisRuleFormDataRouteRestriction
     */
    to?: GeoFormData;
    /**
     * 
     * @type {boolean}
     * @memberof BCMOsisRuleFormDataRouteRestriction
     */
    match?: boolean;
}

export function BCMOsisRuleFormDataRouteRestrictionFromJSON(json: any): BCMOsisRuleFormDataRouteRestriction {
    return BCMOsisRuleFormDataRouteRestrictionFromJSONTyped(json, false);
}

export function BCMOsisRuleFormDataRouteRestrictionFromJSONTyped(json: any, ignoreDiscriminator: boolean): BCMOsisRuleFormDataRouteRestriction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'from': !exists(json, 'from') ? undefined : GeoFormDataFromJSON(json['from']),
        'to': !exists(json, 'to') ? undefined : GeoFormDataFromJSON(json['to']),
        'match': !exists(json, 'match') ? undefined : json['match'],
    };
}

export function BCMOsisRuleFormDataRouteRestrictionToJSON(value?: BCMOsisRuleFormDataRouteRestriction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'from': GeoFormDataToJSON(value.from),
        'to': GeoFormDataToJSON(value.to),
        'match': value.match,
    };
}


